import * as React from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { Stack } from '@mui/material';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius:"4px",
  boxShadow: 24,
  p: 4,
  textAlign:"center"
};
const DeleteModal = ({setOpen,handleDelete,item}) => {

    const handleClose=()=>{
        
        setOpen(false)
    }

  return (
    <div>
          <Modal
        open={true}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography sx={{mb:2}} id="modal-modal-title" variant="h6" component="h2">
         Are you sure that you want to delete this {item} ?
          </Typography>
          
          <Stack direction={"row"} justifyContent={"center"} spacing={1}>
            <Button color='info' variant='contained' onClick={()=>{
              handleDelete()
            }}>
                Yes
            </Button>
            <Button onClick={handleClose} color='error' variant='contained'>
                No
            </Button>
          </Stack>
        </Box>
      </Modal>
    </div>
  )
}

export default DeleteModal